import { render } from "./manage_assigned_workflows.html?vue&type=template&id=21bcdafc&scoped=true&external"
import script from "./manage_assigned_workflows.js?vue&type=script&lang=js&external"
export * from "./manage_assigned_workflows.js?vue&type=script&lang=js&external"

import "./ManageAssignedWorkflows.vue?vue&type=style&index=0&id=21bcdafc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bcdafc"]])

export default __exports__